import { PusherContext } from '@/js/shared/context/PusherContext';
import { INode } from '@/types/node';
import { TWidgets } from '@/widget-editor';
import { useWidgets } from '@/widget-editor/hooks/use-widgets';
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
import * as C from '../../../../shared/constants/general';

interface IProps {
  user: any;
  roomId: string;
}

interface IProvided {
  roomId: string;
  widgets: TWidgets;
  usingDefault: boolean;
  isModerator: () => boolean;
  moderating: boolean;
  reloadWidgets: () => void;
  setModerating: React.Dispatch<React.SetStateAction<boolean>>;
  setWidgetActive: (id: string, active: boolean) => void;
}

export const WidgetContext = createContext<IProvided | undefined>(undefined);

export const WidgetContextProvider: React.FC<IProps> = ({
  children,
  roomId,
  user,
}) => {
  const {
    widgets,
    usingDefault,
    loadWidgets,
    replaceWidgets,
    setWidgetActive,
  } = useWidgets<TWidgets>(roomId, false);

  const { pusher, ROOM_TYPE, actions } = useContext(PusherContext);

  const isModerator = useCallback(
    () => user.access_level === C.VISITOR.ACCESS_LEVEL.MODERATOR,
    [user]
  );

  const [moderating, setModerating] = useState(false);

  useEffect(() => {
    let subscribed = true;

    if (pusher.current == null) return;

    const roomChannel = actions.subscribe(ROOM_TYPE.ROOM, roomId);

    roomChannel.bind('widget-event', (newWidgets: any) => {
      if (newWidgets && newWidgets.hasOwnProperty('widgets')) {
        replaceWidgets(newWidgets.widgets as INode[]);
      }
    });

    roomChannel.bind('widget-reload', () => {
      setTimeout(() => reloadWidgets(), Math.floor(Math.random() * 5000));
    });

    return () => {
      subscribed = false;
      actions.unSubscribe(ROOM_TYPE.ROOM, roomId);
    };
  }, [pusher.current, roomId]);

  const reloadWidgets = () => {
    loadWidgets();
  };
  useEffect(() => {
    reloadWidgets();
  }, [roomId]);

  return (
    <WidgetContext.Provider
      value={{
        roomId,
        widgets,
        usingDefault,
        reloadWidgets,
        isModerator,
        moderating,
        setModerating,
        setWidgetActive,
      }}
    >
      {children}
    </WidgetContext.Provider>
  );
};
